import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { SettingsReferralsCatalogKey } from './settingsReferrals.i18n.js';
import { SETTINGS_REFERRALS_CATALOG } from './settingsReferrals.i18n.js';

export type SettingsReferralsMessageId = `settingsReferrals:${SettingsReferralsCatalogKey}`;

const PREFIX_LENGTH = 'settingsReferrals:'.length;

/** `t()` for the stop-gap `settingsReferrals:` scope (see `settingsReferrals.i18n.ts`). */
export function useSettingsReferralsT(): { t: (id: SettingsReferralsMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: SettingsReferralsMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as SettingsReferralsCatalogKey;
      const raw = SETTINGS_REFERRALS_CATALOG[locale][key] ?? SETTINGS_REFERRALS_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
